import { redirect } from "react-router-dom";
import i18n from "@/i18n";

const LANGS = [
  { code: "en", label: "English", flag: "🇬🇧", hint: "EN" },
  { code: "si", label: "සිංහල", flag: "🇱🇰", hint: "සි" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳", hint: "हि" },
  { code: "ta", label: "தமிழ்", flag: "🇱🇰", hint: "த" },
];

const ALLOWED = new Set(LANGS.map((l) => l.code));

export async function action({ request }) {
  const fd = await request.formData();
  let lang = fd.get("lang");

  if (!ALLOWED.has(lang)) lang = "en";

  try {
    localStorage.setItem("cm_lang", lang);
  } catch {
    // Intentionally ignored: localStorage persistence failure should not block language selection.
  }

  await i18n.changeLanguage(lang);

  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lang);
  }

  return redirect("/");
}
